import { createRequest } from "helpers/tools";

export const zendeskMappings = async (data, id) => {
    return await createRequest({
        suffix: `zendesk_sell/update/${id}`,
        method: "put",
        payload: data,
        handleError: false,
    });
};

export const sendDataZendesk = async (data) => {
    return await createRequest({
        suffix: "zendesk_sell",
        method: "post",
        payload: data,
        handleError: false,
    });
};

export const getZendeskUrl = async () => {
    return await createRequest({
        suffix: `zendesk_sell/auth-url`,
        handleError: true,
        method: "get",
    });
};

export const updateZendeskSource = async (id) => {
    return await createRequest({
        suffix: `zendesk_sell/${id}/fields`,
        method: "get",
        handleError: false,
    });
};

export const getZendeskTrackerEvent = async (sourceId) => {
    return await createRequest({
        suffix: `zendesk_sell/${sourceId}/preview`,
        method: "get",
        handleError: false,
    });
};

export const zendeskReconnect = async (id, data) => {
    return await createRequest({
        suffix: `sources/${id}/service-update`,
        method: "post",
        payload: data,
        handleError: false,
    });
};
